import React from 'react';
import 'twin.macro';

export const TableRow = ({ children, ...restProps }) => (
  <tr tw='border-b border-icons! divide-y-0 border-opacity-60' {...restProps}>
    {children}
  </tr>
);
